import React, { useEffect } from "react";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import ActivitiesCard from "./ActivitiesCard";
import {
  getApprovedRewardList 
} from "../../../../../redux/employeereward/employeeRewardState";
import { Gift } from "lucide-react";

const RecentActivitySummary = ({
  recordList, 
  pagination, 
  doSearch, 
}) => {
  
  useEffect(() => {
    doSearch({paginate: pagination.per_page});
  }, [doSearch, pagination.per_page]);

  return (
    <HeaderComponent
      title="Recent Activity"
      titleClass="text-[16px] font-medium"
      description="Latest credit awards and transactions"
      descriptionClass="text-sm muted-text"
    >
      {recordList?.length === 0 ? (
        <div className="text-center py-8">
          <Gift className="w-12 h-12 text-gray-300 mx-auto mb-3" />
          <p className="text-sm muted-text">No approved rewards yet</p>
        </div>
      ) : (
        <div className="max-h-[600px] overflow-y-auto space-y-2">
          {recordList?.map((item) => (
            <ActivitiesCard key={item?.erw_id} item={item} />
          ))}
        </div>
      )}
    </HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.employeeReward.approvedRewardList?.items,
  pagination: state.employeeReward.approvedRewardList?.pagination,
  requesting: state.employeeReward.approvedRewardList?.requesting,
  filters: state.employeeReward.approvedRewardList?.filters,
  error: state.employeeReward.approvedRewardList?.error,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getApprovedRewardList(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(RecentActivitySummary);
